/* eslint-disable operator-linebreak */
import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Box, ListItemIcon, MenuItem, Popover } from '@mui/material';

import { useMounted } from '@hooks/use-mounted';
import { languageService } from '@services/language-service';
import { errorService } from '@services/error-service';

export const LanguagePopover = function LanguagePopover(props) {
  const { anchorEl, onClose, open, ...other } = props;
  const { i18n, t } = useTranslation();
  const isMounted = useMounted();
  const [languageOptions, setLanguages] = useState(null);

  const getLanguages = useCallback(async () => {
    try {
      const language = await languageService.active();
      if (isMounted()) setLanguages(language.data);
    } catch (err) {
      if (isMounted()) {
        errorService.error(err);
      }
    }
  }, [isMounted]);

  useEffect(() => {
    getLanguages();
  }, [getLanguages]);

  const handleChange = async (language) => {
    onClose?.();
    await languageService.set(language);
    i18n.changeLanguage(language);
    toast.success(t('Language changed'));
  };

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      keepMounted
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 85 } }}
      transitionDuration={0}
      {...other}>
      {languageOptions !== null &&
        languageOptions.map((language) => (
          <MenuItem onClick={() => handleChange(language.id)} key={language.id}>
            <ListItemIcon>
              <Box
                sx={{
                  display: 'flex',
                  height: 50,
                  width: 50,
                  '& img': {
                    width: '100%',
                  },
                }}>
                <img
                  alt={language.name}
                  src={`${process.env.rootPath}${language.icon}`}
                />
              </Box>
            </ListItemIcon>
          </MenuItem>
        ))}
    </Popover>
  );
};

LanguagePopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
LanguagePopover.defaultProps = {
  anchorEl: null,
};
